import L from "leaflet";
import dayjs from "dayjs";
import { getMarkerIcons } from './images';

const STATE_ORDER = ["wait", "pending", "confirmed", "pick", "inland", "pol", "sea", "pod", "customs", "delivered", "completed"]
export function getShipmentStateIndex(state) {
  return STATE_ORDER.indexOf(state)
}


const STATE_COLOR_MAP = {
  wait: {
    color: "#DADCE0",
    display: "WAITING CONFIRMATION",
    title: 'Waiting Confirmation',
  },
  pending: {
    color: "#DADCE0",
    display: "PENDING",
    title: 'Pending',
  },
  confirmed: {
    color: "#DADCE0",
    display: "CONFIRMED",
    title: 'Booking Confirmed',
  },
  containers_assigned: {
    color: "#039BE53D",
    display: "ASSIGNED",
    title: 'Containers Assigned',
  },
  pick: {
    color: "#039BE53D",
    display: "PICKUP",
    title: 'Picked Up',
  },
  inland: {
    color: "#039BE53D",
    display: "INLAND TRUCKING",
    title: 'Inland Trucking',
  },
  pol: {
    color: "#039BE53D",
    display: "POL",
    title: 'In Port of Loading',
  },
  sea: {
    color: "#039BE53D",
    display: "SAILING",
    title: 'Vessel Sailed',
  },
  pod: {
    color: "#3BBD713D",
    display: "POD",
    title: 'Discharged',
  },
  customs: {
    color: "#f8f8b1",
    display: "CUSTOMS",
    title: 'Customs Clearance',
  },
  gateout: {
    color: "#f8f8b1",
    display: "GATE OUT",
    title: 'Gate Out',
  },
  emptyreturn: {
    color: "#f8f8b1",
    display: "EMPTY RETURN",
    title: 'Empty Return',
  },
  delivered: {
    color: "#f8f8b1",
    display: "DELIVERED",
    title: 'Delivered',
  },
  canceled: {
    color: "#bd3b3b3d",
    display: "CANCELLED",
    title: 'Canceled',
  },
  completed: {
    color: "#3BBD713D",
    display: "DONE",
    title: 'Completed',
  },
  skipped: {
    color: "#bd3b3b3d",
    display: "SKIPPED",
    title: 'Skipped',
  },
  wait_cargo_readiness: {
    color: "#DADCE0",
    display: "WAITING CARGO READINESS",
    title: 'Waiting Cargo Readiness',
  }
}

export function getStateColorMap(state) {
  return STATE_COLOR_MAP[state]
}

export function createIcon(url) {
  return L.icon({
    iconUrl: getMarkerIcons(url),
    iconSize: [24, 24],
    iconAnchor: [15, 15],
    popupAnchor: [-3, -10]
  });
}

export function reduceShipmentsToPorts(acc, shipment) {
  if (!shipment.pol) return { ...acc }

  acc[shipment.pol.name] = acc[shipment.pol.name] || { shipments: [], coordinates: [], isPol: false }
  acc[shipment.pod.name] = acc[shipment.pod.name] || { shipments: [], coordinates: [], isPol: false }

  acc[shipment.pol.name].shipments.push(shipment)
  acc[shipment.pol.name].coordinates = shipment.pol.coordinates
  acc[shipment.pol.name].isPol = acc[shipment.pol.name].isPol || true

  acc[shipment.pod.name].shipments.push(shipment)
  acc[shipment.pod.name].coordinates = shipment.pod.coordinates
  acc[shipment.pod.name].isPol = acc[shipment.pod.name].isPol || false

  return {
    ...acc,
  }
}

export function formatLocationDate(date, inFormat = "DD MMM YYYY", outFormat = "DD MMM") {
  const parsedDate = dayjs(date, inFormat);
  if (!parsedDate.isValid()) {
    return "To be advised";
  }
  return parsedDate.format(outFormat);
}

const METRIC_DESCRIPTION = {
  price: {
    subtitle: "Secured Within The Lowest Market Prices.",
    prefix: "%",
    suffix: "of your bookings",
  },
  track: {
    subtitle: "Saved to track your shipments.",
    prefix: "+",
    suffix: "hrs of effort",
  },
  search: {
    subtitle: "Saved to find the best quotation.",
    prefix: "+",
    suffix: "hrs of effort",
  },
  profit: {
    subtitle: "Profit Share",
    prefix: "$",
    suffix: "",
  }
}

export function formatMetric(metric) {
  return METRIC_DESCRIPTION[metric]
}
